<template>
  <v-dialog v-model="manageScriptDialog" width="60%" persistent>
    <v-card>
      <v-card-title>Manage Script</v-card-title>
      <v-card-text>
        <v-text-field label="Name" v-model="active.name" color="primary" />
        <v-textarea label="Detail" v-model="active.details" color="primary" />
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn :loading="isLoading" :disabled="isLoading" text color="primary" @click="closeDialog">Cancel</v-btn>
        <v-btn :loading="isLoading" :disabled="isLoading" color="primary" @click="saveScript">Save Script</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import {ScriptsHttp} from "@/http/ScriptsHttp";
export default {
  name: "ScriptModal",
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapState("scripts", ["manageScriptDialog", "activeScript"]),
    active: {
      get() {
        return this.activeScript;
      }
    }
  },
  methods: {
    ...mapActions("scripts", ["setScripts", "setActiveScript", "setManageScriptDialog", "setManageDeleteScriptDialog"]),
    ...mapMutations("app", ["setToast"]),
    async saveScript() {
      try {
        this.isLoading = true;
        if (!this.active._id) {
          await ScriptsHttp.createNewScript(this.active);
        } else {
          await ScriptsHttp.updateScript(this.active);
        }
        this.setToast({color: 'success', text: 'Script saved successfully', show: true});
        await this.setScripts();
        await this.setActiveScript({});
        await this.setManageScriptDialog(false);
      } catch (err) {
        this.setToast({color: 'error', text: err.response.data, show: true})
      } finally {
        this.isLoading = false;
      }
    },
    async closeDialog() {
      await this.setActiveScript({});
      await this.setManageScriptDialog(false);
    }
  }
}
</script>

<style scoped>

</style>
